import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { I18nProvider } from './i18n';
import 'leaflet/dist/leaflet.css';
import '@fontsource-variable/dm-sans/opsz.css';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

// A data router is required for useBlocker (unsaved-changes guard); the single splat route keeps
// the existing <Routes> tree inside App as descendant routes.
const router = createBrowserRouter([{ path: '*', element: <App /> }]);

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <I18nProvider>
      <RouterProvider router={router} />
    </I18nProvider>
  </React.StrictMode>
);
